import { UNSUPPORTED_AI_IMAGE_EXTENSIONS, UnsupportedImageSuffix } from '../../../../utils/get-is-ai-supported';
export let DisabledButtonTooltipTranslationKeySuffix = /*#__PURE__*/function (DisabledButtonTooltipTranslationKeySuffix) {
  DisabledButtonTooltipTranslationKeySuffix["SITE_NOT_PREMIUM"] = "site-not-premium";
  DisabledButtonTooltipTranslationKeySuffix["NO_MISSING_ALT_TEXT"] = "no-missing-alt-text";
  DisabledButtonTooltipTranslationKeySuffix["ALL_SVG"] = "all-svg";
  DisabledButtonTooltipTranslationKeySuffix["ALL_GIF"] = "all-gif";
  DisabledButtonTooltipTranslationKeySuffix["ALL_AVIF"] = "all-avif";
  DisabledButtonTooltipTranslationKeySuffix["ALL_APNG"] = "all-apng";
  DisabledButtonTooltipTranslationKeySuffix["ALL_MIX_UNSUPPORTED"] = "all-mix-unsupported";
  DisabledButtonTooltipTranslationKeySuffix["FAIL_TO_AI"] = "fail-to-ai";
  return DisabledButtonTooltipTranslationKeySuffix;
}({});
export const getDisabledButtonTooltipTranslationKeySuffix = (items, isGenerating) => {
  if (isGenerating) {
    return undefined;
  }
  if (!(items != null && items.length) || items.length === 0) {
    return DisabledButtonTooltipTranslationKeySuffix.NO_MISSING_ALT_TEXT;
  }
  const allSvg = items.every(_ref => {
    let {
      url
    } = _ref;
    return url.endsWith(UnsupportedImageSuffix.SVG);
  });
  if (allSvg) {
    return DisabledButtonTooltipTranslationKeySuffix.ALL_SVG;
  }
  const allGif = items.every(_ref2 => {
    let {
      url
    } = _ref2;
    return url.endsWith(UnsupportedImageSuffix.GIF);
  });
  if (allGif) {
    return DisabledButtonTooltipTranslationKeySuffix.ALL_GIF;
  }
  const allAvif = items.every(_ref3 => {
    let {
      url
    } = _ref3;
    return url.endsWith(UnsupportedImageSuffix.AVIF);
  });
  if (allAvif) {
    return DisabledButtonTooltipTranslationKeySuffix.ALL_AVIF;
  }
  const allApng = items.every(_ref4 => {
    let {
      url
    } = _ref4;
    return url.endsWith(UnsupportedImageSuffix.APNG);
  });
  if (allApng) {
    return DisabledButtonTooltipTranslationKeySuffix.ALL_APNG;
  }
  const allMixUnsupported = items.every(_ref5 => {
    let {
      url
    } = _ref5;
    return UNSUPPORTED_AI_IMAGE_EXTENSIONS.some(suffix => url.endsWith(suffix));
  });
  if (allMixUnsupported) {
    return DisabledButtonTooltipTranslationKeySuffix.ALL_MIX_UNSUPPORTED;
  }
  return undefined;
};
//# sourceMappingURL=get-disabled-button-tooltip-translation-key-suffix.js.map